import { getPayspotStatuses } from 'admin/actions/devices';
import { toQueryParams } from 'admin/utils';
import { ListItem } from 'material-ui/List';
import DoneIcon from 'material-ui/svg-icons/action/done';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { parseErrorData } from '../../parsingData';
import { PayspotDetailsCard, PayspotDetailsCardTitle } from '../PayspotDetailsCard';

const Flex = styled.div`
  display: flex;
  ${({ flexDirection }) => flexDirection && `flex-direction: ${flexDirection};`}
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
`;

const ErrorList = styled.div`
  height: 300px;
  overflow-y: auto;
`;

const Center = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PayspotErrorsCard = ({ payspotId }) => {
  const [statuses, setStatuses] = useState({
    rows: [],
    count: 0,
    pagination: {},
  });

  const fetchPayspotStatuses = (id, pagination = {}) => {
    const params = {
      page: 1,
      per_page: 50,
      ...pagination,
    };
    getPayspotStatuses(id, toQueryParams(params)).then(setStatuses);
  };

  useEffect(() => {
    fetchPayspotStatuses(payspotId);
  }, [payspotId]);

  const NoErrors = (
    <Flex flexDirection="column" alignItems="center">
      <DoneIcon style={{ color: '#00a23f', width: 80, height: 80 }} />
      <span style={{ color: 'gray', fontStyle: 'italic' }}>正常稼働中</span>
    </Flex>
  );

  return (
    <PayspotDetailsCard>
      <PayspotDetailsCardTitle>エラー一覧</PayspotDetailsCardTitle>
      <ErrorList>
        {(statuses.rows.length === 0 || statuses.rows[0].errors.length === 0) && (
          <Center>{NoErrors}</Center>
        )}
        {statuses.rows.length > 0 &&
          statuses.rows[0].errors.map((error) => (
            <ListItem
              key={error.description}
              primaryText={parseErrorData(error.description)}
              style={{ borderBottom: '1px solid #e5e5e5' }}
            />
          ))}
      </ErrorList>
    </PayspotDetailsCard>
  );
};

PayspotErrorsCard.propTypes = {
  payspotId: PropTypes.string.isRequired,
};

export default PayspotErrorsCard;
